import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import StudentReport from "./StudentReport";
import { toast } from "react-toastify";
import ReportLoader from "./GenerateLoader";

const StudentReportDialog = ({
  isOpen,
  onClose,
  isMobileView,
  studentId,
  classroomId,
}) => {
  const [loading, setLoading] = useState(false);
  const [detailedReport, setDetailedReport] = useState({});

  // 🔹 API call handler
  const getStudentDetailedReport = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_AI_API_URL}/?user=${studentId}&classroom=${classroomId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch users");
      }

      const data = await response.json();
      setDetailedReport(data);
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStudentDetailedReport();
  }, []);

  return (
    <Modal
      show={isOpen}
      className={`ask-question-section-dialog ${
        isMobileView ? "" : "modal-xl"
      }`}
      onHide={onClose}
      centered
    >
      {loading && <ReportLoader />}
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title> {loading ? "" : "Student Detailed Report"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {Object.keys(detailedReport)?.length ? (
          <StudentReport reportData={detailedReport} />
        ) : (
          <div>{loading ? "" : "No data found."}</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default StudentReportDialog;
